import * as Yup from "yup";
import { TFunction } from "i18next";

type Translator = (key: string, vars?: Record<string, any>) => string;

export default function saveBillRateSchema(t: TFunction | Translator) {

  return Yup.object().shape({
  
    billrate_start_date: Yup.date()
      .required(
        t("Rate.validations.required", {
          value: t("Rate.start_date"),
        })
      )
      .test(
        "is-sunday",
        t("Rate.validations.mustBeSunday", { value: t("Rate.start_date") }),
        (value) => value && new Date(value).getDay() === 0 // 0 = Sunday
      ),

    billrate_type: Yup.string()
    .required(
      t("Rate.validations.required", {
        value: t("Rate.type"),
      })
    ),

  });
}